/**
 * Bekräftelsefråga innan något tas bort eller ändras på ett sätt som är svårt att ångra.
 * Ett ställe att byta till en egen dialog senare, i stället för window.confirm på 30 ställen.
 */
export function confirmAction(message: string): boolean {
    return window.confirm(message);
}

/** Vanlig formulering vid borttagning: "Ta bort X?" plus en valfri rad om följderna. */
export function confirmDelete(what: string, consequence?: string): boolean {
    return confirmAction(consequence ? `Ta bort ${what}?\n\n${consequence}` : `Ta bort ${what}?`);
}

/** Varning när en larmregel med historik ska tas bort: händelserna och avvikelserapporterna följer med. */
export function historyWarning(count: number): string {
    return `Regeln har ${count} larmhändelse${count === 1 ? '' : 'r'} i historiken.\n\n` +
        `Tar du bort regeln försvinner också händelserna och deras avvikelserapporter för gott. ` +
        `Vill du hellre behålla historiken kan du stänga av regeln i stället.\n\nTa bort ändå?`;
}
